import {
  BenefitDesignQuotesList,
  ShopInsuranceQuotesList,
  JointPolicyComingSoon,
  type BenefitDesignQuoteGroup,
  type PaymentOption,
  type ShopInsuranceMode,
  type TraditionalLTCQuoteWithROI,
  type QuoteWithROI,
} from '@/features/shop-insurance';
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';

interface ShopInsuranceTabContentProps {
  filteredAdjustedQuotes: QuoteWithROI[];
  filteredTraditionalLTCQuotesWithEligibility: TraditionalLTCQuoteWithROI[];
  expandedIndices: number[];
  selectedTab: ShopInsuranceTab;
  clientPartner: any;
  premiumValue: number;
  paymentOption: PaymentOption;
  advisorId: string;
  isQuoteSelected: (quote: any) => { isSelected: boolean; fundingSourceId: string | null };
  handleCardToggle: (index: number) => void;
  onClose: () => void;
  knownLimitationError?: QuoteError | null;
  hasSameGenderPartner: boolean;
  mode?: ShopInsuranceMode;
  benefitDesignQuoteGroups?: BenefitDesignQuoteGroup[];
  stateOfResidence?: string;
}

export function ShopInsuranceTabContent({
  filteredAdjustedQuotes,
  filteredTraditionalLTCQuotesWithEligibility,
  expandedIndices,
  selectedTab,
  clientPartner,
  premiumValue,
  paymentOption,
  advisorId,
  isQuoteSelected,
  handleCardToggle,
  onClose,
  knownLimitationError,
  hasSameGenderPartner,
  mode = 'premium-optimization',
  benefitDesignQuoteGroups = [],
  stateOfResidence,
}: ShopInsuranceTabContentProps) {
  const { flags } = useFeatureFlags();

  if (selectedTab === 'joint' && hasSameGenderPartner) {
    return <JointPolicyComingSoon />;
  }

  const traditionalLTCQuotes =
    flags.nycLifeDemo || mode === 'benefit-design'
      ? []
      : filteredTraditionalLTCQuotesWithEligibility;
  const sharedListProps = {
    filteredTraditionalLTCQuotesWithEligibility: traditionalLTCQuotes,
    expandedIndices,
    selectedTab,
    clientPartner,
    paymentOption,
    advisorId,
    isQuoteSelected,
    handleCardToggle,
    onClose,
    knownLimitationError,
  };

  return (
    <div
      data-testid="shop-insurance-quotes-list"
      className="flex w-full flex-col"
    >
      {mode === 'benefit-design' ? (
        <BenefitDesignQuotesList
          quoteGroups={benefitDesignQuoteGroups}
          filteredTraditionalLTCQuotesWithEligibility={traditionalLTCQuotes}
          selectedTab={selectedTab}
          clientPartner={clientPartner}
          paymentOption={paymentOption}
          advisorId={advisorId}
          isQuoteSelected={isQuoteSelected}
          onClose={onClose}
          knownLimitationError={knownLimitationError}
        />
      ) : (
        <ShopInsuranceQuotesList
          filteredAdjustedQuotes={filteredAdjustedQuotes}
          premiumValue={premiumValue}
          stateOfResidence={stateOfResidence}
          {...sharedListProps}
        />
      )}
    </div>
  );
}
